import React from 'react';
const YogaStudios = () => <div className="service-page"><h1>Yoga Studios</h1><p>Find the best yoga studios and instructors near you.</p></div>;
export default YogaStudios;
